// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { omit, isEqual, cloneDeep } from 'lodash';
import { Compare, DiffedLayer } from '../features/config/types/configurations';

export enum DiffStatuses {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted'
}

const getItem = (layers: object, item: any): any => {
  const layersArray = Object.values(layers);
  if (item.isRootFolder) {
    return layersArray.find(prevItem => prevItem.isRootFolder);
  }
  return layersArray.find(prevItem => prevItem.id === item.id);
};

const treeWalker = (previousLayers: Compare, currentLayers: Compare, item: DiffedLayer): DiffedLayer => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  const previousItem = getItem(previousLayers, item);

  if (item.status !== DiffStatuses.DELETED) {
    if (!previousItem) {
      item.status = DiffStatuses.CREATED;
    } else if (!isEqual(omit(cloneDeep(previousItem), ['children']), omit(cloneDeep(item), ['children']))) {
      item.history = {
        currentItem: omit(cloneDeep(item), ['children']),
        prevItem: omit(cloneDeep(previousItem), ['children']),
      };
      item.status = DiffStatuses.UPDATED;
    }
  }

  if (item.children) {
    item.children = item.children.map((key: string) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return treeWalker(previousLayers, currentLayers, currentLayers[key as keyof Compare]);
    });
    if (item.children.find(item => item.status) && !item.status) {
      item.status = DiffStatuses.UPDATED;
    }
  }

  return item;
};

export const diffLayers = (previousLayers: Compare, currentLayers: Compare): DiffedLayer => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  const root = Object.values(currentLayers).find(item => item.isRootFolder) as DiffedLayer;
  return treeWalker(previousLayers || {}, currentLayers, root);
};

const findParent = (layers: object, id: string): any => {
  const index = Object.values(layers).findIndex(layer => layer.id === id);
  const key = Object.keys(layers)[index];
  return Object.values(layers).find(item => item.children?.includes(key));
};

export const copyDeletedLayers = (previousLayers?: object | null, currentLayers: object): Compare[] => {
  if (!previousLayers) {
    return [previousLayers, currentLayers];
  }

  const previousLayersArray = Object.values(previousLayers);
  const currentLayersArray = Object.values(currentLayers);

  for (const key in previousLayers) {
    const id = previousLayers[key]?.id as string;
    if (id) {
      const exist = currentLayersArray.find(item => item.id === id) && findParent(previousLayers, id)?.id === findParent(currentLayers, id)?.id;
      if (!exist) {
        const parent = previousLayersArray.find(item => item.children?.includes(key));
        if (parent) {
          if (parent.isRootFolder) {
            const rootParent = currentLayersArray.find(item => item.isRootFolder);
            rootParent.children.push(`${key}.deleted`);
          } else {
            const currentParent = currentLayersArray.find(item => item.id === parent.id);
            if (currentParent) {
              currentParent.children = currentParent.children ? [...currentParent.children, `${key}.deleted`] : [`${key}.deleted`];
            }
          }
        }
        const previous = cloneDeep(previousLayersArray.find(item => item.id === previousLayers[key].id));
        if (previous.children) {
          previous.children = previous.children.map((key: string) => `${key}.deleted`);
        }
        currentLayers[`${key}.deleted`] = { ...previous, status: DiffStatuses.DELETED };
      }
    }
  }
  return [previousLayers, currentLayers];
};
